// @flow
import {
    fetchLiveCatalogStatusFromPubnub,
    fetchLiveCatalogStatusIfNeeded,
} from '../../redux/modules/liveCatalogStatus';
import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { type Catalog } from '../../types/Catalog';
import CatalogCard from './CatalogCard';
import clamp from 'lodash/clamp';
import { connect } from 'react-redux';
import { getLiveCatalogData } from '../../redux/modules/console';
import PubnubCatalogContainer from '../../components/PubnubContainer/PubnubCatalogContainer';
import type { Seller } from '@liveauctioneers/flow-types/lib/Seller';
import { shouldShowLive } from '../../utils/live';

const mapStateToProps = (state, { cardViewModel, className, featured, trackClick }) => {
    const { catalog } = cardViewModel;
    const { absenteeBidders = 0, catalogId, lotsListed } = catalog;
    const { bidders, currentItemIndex } = getLiveCatalogData(state, catalogId);
    const { catalogStatus, hasVideo, isCatalogOnly, saleStartTs } = catalog || {};
    const showLive = shouldShowLive(catalogStatus, isCatalogOnly, saleStartTs);
    let percentComplete = 2.5; // default is set at the lowest we allow;
    // if either of these numbers are undefined, we'll just return the minimum
    if (!Number.isNaN(currentItemIndex) && !Number.isNaN(lotsListed)) {
        percentComplete = clamp(((currentItemIndex + 1) / lotsListed) * 100, 2.5, 100);
    }

    return {
        bidders: bidders + absenteeBidders,
        cardViewModel,
        catalogId,
        className,
        featured,
        hasVideo,
        percentComplete,
        showLive,
        trackClick,
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchLiveCatalogStatusFromPubnub,
            fetchLiveCatalogStatusIfNeeded,
        },
        dispatch
    );

type CatalogCardViewModel = {
    catalog: Catalog,
    coverLots: any,
    seller: Seller,
    trending: boolean,
};

type Props = {
    bidders: number,
    cardViewModel: CatalogCardViewModel,
    catalogId: number,
    className: string,
    featured: boolean,
    fetchLiveCatalogStatusFromPubnub: Function,
    fetchLiveCatalogStatusIfNeeded: Function,
    followed?: boolean,
    hasVideo: boolean,
    homepage: boolean,
    horizontal: boolean,
    percentComplete: number,
    preview: boolean,
    showLive: boolean,
    showSendSellerConsignmentMessageModal?: Function,
    skipVisibilityCheck: boolean,
    style: any,
    trackClick: Function,
};

class CatalogCardContainer extends Component<Props> {
    componentDidMount() {
        if (this.props.showLive) {
            this.props.fetchLiveCatalogStatusIfNeeded(this.props.catalogId);
            if (this.props.homepage) {
                this.props.fetchLiveCatalogStatusFromPubnub(this.props.catalogId);
            }
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.showLive && this.props.showLive) {
            this.props.fetchLiveCatalogStatusIfNeeded(this.props.catalogId);
            if (this.props.homepage) {
                this.props.fetchLiveCatalogStatusFromPubnub(this.props.catalogId);
            }
        }
    }

    render() {
        const {
            bidders,
            cardViewModel,
            catalogId,
            className,
            featured,
            followed,
            hasVideo,
            homepage,
            horizontal,
            percentComplete,
            preview,
            showLive,
            showSendSellerConsignmentMessageModal,
            skipVisibilityCheck,
            style,
            trackClick,
        } = this.props;

        const { catalog, coverLots, seller, trending } = cardViewModel;

        return (
            <Fragment>
                {showLive && !homepage && (
                    <PubnubCatalogContainer catalogId={catalogId} limitMessagesFilter="catalogCard" />
                )}
                <CatalogCard
                    bidders={bidders}
                    catalog={catalog}
                    className={className}
                    coverLots={coverLots}
                    featured={featured}
                    followed={followed}
                    hasVideo={hasVideo}
                    horizontal={horizontal}
                    percentComplete={percentComplete}
                    preview={preview}
                    seller={seller}
                    showLive={showLive}
                    showSendSellerConsignmentMessageModal={showSendSellerConsignmentMessageModal}
                    skipVisibilityCheck={skipVisibilityCheck}
                    style={style}
                    trackClick={trackClick}
                    trending={trending}
                />
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogCardContainer);
